<template>
  <div>
    <button-edit
      :id="model.item.id"
      class="mr-2"
    />
    <button-seating-status :id="model.item.id" />
  </div>
</template>

<script>
import ButtonEdit from './Edit'
import ButtonSeatingStatus from './SeatingStatus'

export default {
  components: {
    ButtonEdit,
    ButtonSeatingStatus
  },

  props: {
    model: {
      required: true,
      type: Object
    }
  }
}
</script>
